import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable, inject} from '@angular/core';
import {
    DEFUALT_SEARCH,
    ILocation,
    ILocationActivate,
    ILocationCreate,
    ILocationSelect,
    IPagedData,
    IPagedSearch,
    LocationProjection,
    mongoQueryParser,
} from '@evencel/models';
import {Observable, map} from 'rxjs';

export const LOCATION_URL = 'locations';

@Injectable({providedIn: 'root'})
export class LocationService {
    httpClient = inject(HttpClient);

    post(data: ILocationCreate): Observable<ILocation> {
        return this.httpClient.post<ILocation>(LOCATION_URL, data);
    }

    patch(data: ILocation): Observable<ILocation> {
        const url = `${LOCATION_URL}/${data._id}`;
        return this.httpClient.patch<ILocation>(url, data);
    }

    activate(data: ILocationActivate): Observable<ILocation> {
        const {active} = data;
        const url = `${LOCATION_URL}/${data._id}/activate`;
        return this.httpClient.patch<ILocation>(url, {active});
    }

    delete(id: string): Observable<void> {
        return this.httpClient.delete<void>(`${LOCATION_URL}/${id}`);
    }

    restore(id: string): Observable<void> {
        return this.httpClient.delete<void>(`${LOCATION_URL}/${id}/restore`);
    }

    private searchParams(data: IPagedSearch) {
        const {active, direction} = data.sort;
        const {pageIndex, pageSize} = data.page;
        let params = new HttpParams();
        params = params.append('pageIndex', `${pageIndex}`);
        params = params.append('pageSize', `${pageSize}`);
        params = params.append('sort', active);
        params = params.append('order', direction);
        params = params.append('projection', data.projection || 'dataTable');
        return params;
    }

    searchByName(name: string) {
        const condition = mongoQueryParser.parse({name: {$regex: name}});
        const action: IPagedSearch = {
            ...DEFUALT_SEARCH,
            projection: LocationProjection.select,
            condition,
        };
        return this.search<ILocationSelect>(action).pipe(map(d => d.data));
    }

    search<T = ILocation>(data: IPagedSearch): Observable<IPagedData<T>> {
        const params = this.searchParams(data);
        return this.httpClient.post<IPagedData<T>>(`${LOCATION_URL}/search`, data.condition, {params});
    }

    getOne(id: string): Observable<ILocation> {
        let params = new HttpParams();
        params = params.append('projection', `form`);
        const url = `${LOCATION_URL}/${id}`;
        return this.httpClient.get<ILocation>(url, {params});
    }

    get(data: IPagedSearch): Observable<IPagedData<ILocation>> {
        const params = this.searchParams(data);
        return this.httpClient.get<IPagedData<ILocation>>(LOCATION_URL, {params});
    }
}
